'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { ProductCardSkeleton } from 'src/features/product-card/Content/Skeleton';
import { CardPositionProvider } from './CardPositionContext';
import { useCardOrdering } from './store/hooks/useCardOrdering';
export function OrderedCardList(t0) {
  const $ = _c(11);
  const {
    productCardsByOfferId,
    allOfferIds,
    productCardSequence,
    className
  } = t0;
  const {
    orderedIds,
    isLoading
  } = useCardOrdering(allOfferIds, productCardSequence, "productCards");
  const idsToRender = isLoading ? allOfferIds : orderedIds;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      listStyle: "none",
      padding: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== idsToRender || $[2] !== isLoading || $[3] !== productCardsByOfferId) {
    let t3;
    if ($[5] !== isLoading || $[6] !== productCardsByOfferId) {
      t3 = (id, index) => {
        if (isLoading) {
          return <li key={id}><ProductCardSkeleton isSpotlight={false} /></li>;
        }
        const child = productCardsByOfferId[id];
        if (!child) {
          return null;
        }
        return <CardPositionProvider key={id} value={index}>{child}</CardPositionProvider>;
      };
      $[5] = isLoading;
      $[6] = productCardsByOfferId;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    t2 = idsToRender.map(t3);
    $[1] = idsToRender;
    $[2] = isLoading;
    $[3] = productCardsByOfferId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[8] !== className || $[9] !== t2) {
    t3 = <ul id="roundup-product-cards-section" className={className} style={t1}>{t2}</ul>;
    $[8] = className;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}